export type OxcBodyStatementJsxMode =
  | "dom-node"
  | "compat-object"
  | "server-string"
  | "unsupported";
